import BankLogo from './BankLogo';
import ArrowRight from '../svgs/ArrowRight';
import { BankComponent } from './BankComponent';
import { Bank } from '../../services/interfaces/bank.interface';

interface BankRowProps {
	bank: Bank;
	onBankSelect(bank: Bank): void;
}

export const BankRow = ({ bank, onBankSelect }: BankRowProps) => {
	const bankName = bank.name;

	return (
		<BankComponent
			logo={<BankLogo bankName={bankName} />}
			title={<span>{bankName}</span>}
			icon={<ArrowRight style={{ opacity: 0.7 }} />}
			onBankComponentClick={() => onBankSelect(bank)}
		/>
	);
};
